import type { User } from '../api/types';

export interface ReviewContext {
  author?: string;
  recipient?: string;
  project?: string;
  regulation?: string;
  stage?: string;
  asset?: string;
}
export function reviewContextFrom(value?: ReviewContext): ReviewContext {
  return Object.fromEntries(['author', 'recipient', 'project', 'regulation', 'stage', 'asset']
    .flatMap(key => { const text = value?.[key as keyof ReviewContext]; return text ? [[key, text]] : []; }));
}
export function fullName(user?: Partial<User> | null) {
  return user ? [user.last_name, user.first_name, user.patronymic].filter(Boolean).join(' ') || user.initial || user.login || '' : '';
}
